import { http, uploadFile } from '@/utils/axios'

/**
 * @msg: 获取教师作业列表
 */
export function getHomeworkList(data) {
  return http({
    url: http.baseUrl('zkolHomework/getHomeworkList'),
    method: 'get',
    params: http.params(data)
  })
}
export function getHomework(data) {
  return http({
    url: http.baseUrl('zkolHomework/getHomework'),
    method: 'get',
    params: http.params(data)
  })
}
export function saveZkolHomework(data, filedata, content, answer) {
  let formData = new FormData();
  formData.append('file', filedata);
  formData.append('content', content);
  formData.append('answer', answer);
  return http({
    url: http.baseUrl('zkolHomework/saveZkolHomework'),
    method: 'post',
    params: http.params(data),
    data: formData
  })
}
export function getHomeworkAnswerList(data) {
  return http({
    url: http.baseUrl('zkolHomework/getHomeworkAnswerList'),
    method: 'get',
    params: http.params(data)
  })
}

export function getHomeworkAnswerInfo(data) {
  return http({
    url: http.baseUrl('zkolHomework/getHomeworkAnswerInfo'),
    method: 'get',
    params: http.params(data)
  })
}

export function getFile(data) {
  return http({
    url: http.baseUrl('zkolHomework/getFile'),
    method: 'get',
    responseType: 'blob',
    params: http.params(data)
  })
}

export function saveHomeworkMarking(data, filedata) {
  let formData = new FormData();
  formData.append('file', filedata);
  return http({
    url: http.baseUrl('zkolHomework/saveHomeworkMarking'),
    method: 'post',
    params: http.params(data),
    data: formData
  })
}

export function getStudentHomeworkList(data) {
  return http({
    url: http.baseUrl('zkolHomework/getStudentHomeworkList'),
    method: 'get',
    params: http.params(data)
  })
}

export function getStudentHomeworkInfo(data) {
  return http({
    url: http.baseUrl('zkolHomework/getStudentHomeworkInfo'),
    method: 'get',
    params: http.params(data)
  })
}

export function saveStudentAnswer(data, filedata, answerContent) {
  let formData = new FormData();
  formData.append('file', filedata);
  formData.append('answerContent', answerContent);
  return http({
    url: http.baseUrl('zkolHomework/saveStudentAnswer'),
    method: 'post',
    params: http.params(data),
    data: formData
  })
}

export function getRole(data) {
  return http({
    url: http.baseUrl('zkolHomework/getRole'),
    method: 'get',
    params: http.params(data)
  })
}

/**
 * @msg: 通过uid获取用户
 */
export function getUserByUid(uid) {
  return http({
    url: http.baseUrl('elUser/getUserByUid'),
    method: 'get',
    params: http.params({
      uid
    })
  })
}

/**
 * 是否有权限添加
 */
export function getCourseTeacherId(createUserid,courseId) {
  return http({
    url: http.baseUrl('zkolHomework/getCourseTeacherId'),
    method: 'get',
    params: http.params({
      createUserid,
      courseId
    })
  })
}
